import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { RiArrowDropDownLine } from "react-icons/ri";
import "../styles/Navbar.css";
import headerLogo from "../Assets/Images/Logo.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [industriesOpen, setIndustriesOpen] = useState(false);
  const [resourcesOpen, setResourcesOpen] = useState(false);

  const resourcesRef = useRef(null);
  const servicesRef = useRef(null);
  const industriesRef = useRef(null);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    if (menuOpen) closeDropdowns();
  };

  const closeMenu = () => {
    setMenuOpen(false);
    closeDropdowns();
  };

  const toggleServices = () => {
    setServicesOpen(!servicesOpen);
    setIndustriesOpen(false);
    setResourcesOpen(false);
  };

  const toggleIndustries = () => {
    setIndustriesOpen(!industriesOpen);
    setServicesOpen(false);
    setResourcesOpen(false);
  };

  const toggleResources = () => {
    setResourcesOpen(!resourcesOpen);
    setIndustriesOpen(false);
    setServicesOpen(false);
  };

  const closeDropdowns = () => {
    setServicesOpen(false);
    setIndustriesOpen(false);
    setResourcesOpen(false);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        servicesRef.current &&
        !servicesRef.current.contains(event.target) &&
        industriesRef.current &&
        !industriesRef.current.contains(event.target) &&
        resourcesRef.current &&
        !resourcesRef.current.contains(event.target)
      ) {
        closeDropdowns();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <nav className="navbar">
      {/* Logo Section */}
      <div className="logo-section">
        <img src={headerLogo} alt="Company Logo" className="logo-image" />
        <p className="logo-text">Accelerate with Accuracy</p>
      </div>

      <div className="menu-toggle" onClick={toggleMenu}>
        <span className="menu-icon">&#9776;</span>
      </div>

      <ul className={`nav-tabs ${menuOpen ? "show-menu" : ""}`}>
        <li className="tab-item">
          <Link
            to="/"
            className="nav-link"
            onClick={() => {
              closeMenu();
              scrollToTop();
            }}
          >
            Home
          </Link>
        </li>

        <li className="tab-item">
          <Link
            to="/products"
            className="nav-link"
            onClick={() => {
              closeMenu();
              scrollToTop();
            }}
          >
            Akscel
          </Link>
        </li>

        {/* Services Dropdown */}
        <li className="tab-item dropdown" ref={servicesRef}>
          <button className="nav-link dropdown-toggle" onClick={toggleServices}>
            Services{" "}
            <span className="dropdown-icon">
              <RiArrowDropDownLine />
            </span>
          </button>
          {servicesOpen && (
            <ul className="dropdown-menu">
              {[
                "ApplicationDevelopment",
                "CloudOptimization",
                "DataAndAnalyticalSolutions",
                "DevSecOps",
                "ProductDevelopment",
                "QualityAssurance",
                "StaffAugumentation",
                "UxUiDesigning",
                "AIsolutions",
              ].map((key) => {
                const exceptions = {
                  DevSecOps: "DevSecOps",
                  AIsolutions: "AI & ML Solutions",
                };

                 const label =
                   exceptions[key] || key.replace(/([A-Z])/g, " $1").trim();

                return (
                  <li key={key}>
                    <Link
                      to={`/services/${key}`}
                      className="dropdown-item"
                      onClick={() => {
                        closeMenu();
                        scrollToTop();
                      }}
                    >
                      {label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          )}
        </li>

        {/* Industries Dropdown */}
        <li className="tab-item dropdown" ref={industriesRef}>
          <button
            className="nav-link dropdown-toggle"
            onClick={toggleIndustries}
          >
            Industries{" "}
            <span className="dropdown-icon">
              <RiArrowDropDownLine />
            </span>
          </button>
          {industriesOpen && (
            <ul className="dropdown-menu">
              {[
                "Healthcare",
                "Fintech",
                "SupplyChain",
                "Government",
                "Agriculture",
                "Entertainment",
                "Education",
                "Hospitality",
              ].map((key) => (
                <li key={key}>
                  <Link
                    to={`/industries/${key}`}
                    className="dropdown-item"
                    onClick={() => {
                      closeMenu();
                      scrollToTop();
                    }}
                  >
                    {key.replace(/([A-Z])/g, " $1").trim()}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>

        <li className="tab-item">
          <Link
            to="/about"
            className="nav-link"
            onClick={() => {
              closeMenu();
              scrollToTop();
            }}
          >
            About
          </Link>
        </li>

        <li className="tab-item dropdown" ref={resourcesRef}>
          <button
            className="nav-link dropdown-toggle"
            onClick={toggleResources}
          >
            Resources{" "}
            <span className="dropdown-icon">
              <RiArrowDropDownLine />
            </span>
          </button>
          {resourcesOpen && (
            <ul className="dropdown-menu">
              {["careers", "blogs"].map((key) => (
                <li key={key}>
                  <Link
                    to={`/${key}`}
                    className="dropdown-item"
                    onClick={() => {
                      closeMenu();
                      scrollToTop();
                    }}
                  >
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </li>

        <li className="tab-item">
          <Link
            to="/founders-program"
            className="nav-link"
            onClick={() => {
              closeMenu();
              scrollToTop();
            }}
          >
            Founders Program
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default Navbar;
